import { NpsActivityQuery } from "../lib/npsActivityQuery"
import { useDashboardQuery } from "./useDashboardQuery"

export function useNpsActivityQuery(...args: Parameters<typeof NpsActivityQuery>) {
  return useDashboardQuery(NpsActivityQuery(...args))
}
